/* eslint-disable @typescript-eslint/no-explicit-any */
import { DROPDOWN_TAG_ICON, ONE_LINE } from 'assets/images'
import { useOnClickOutside } from 'hooks'
import { useRef, useState } from 'react'
import SelectCustomStyled from './styled'
import { GUILD_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'

interface PropsSelectCustom {
  nameSelect?: string
  imgSelect?: any
  dataSelect: any
  onSelected: (item: string) => void
  customClass?: string
  disabled?: boolean
  isFiltered?: boolean
  isShowModal?: boolean
  onShowModal?: () => void
  isShowIcon?: boolean
}
function SelectCustomCreateRace({
  nameSelect,
  dataSelect,
  onSelected,
  customClass = '',
  disabled,
  isShowModal = false,
  onShowModal,
  isShowIcon = false,
}: PropsSelectCustom) {
  const selectRef = useRef(null)
  const { t } = useTranslation()
  const [show, setShow] = useState(false)

  useOnClickOutside(selectRef, e => {
    if (e.target == selectRef.current) {
      return
    }
    setShow(false)
  })

  return (
    <SelectCustomStyled>
      <div
        className={`select-box-customs ${customClass}`}
        onClick={() => {
          setShow(!show)
          isShowModal && onShowModal?.()
        }}
        ref={selectRef}
      >
        <span className='select-name'>
          {isShowIcon ? (
            <div className='name-icon'>
              <div>{dataSelect?.find((opt: any) => opt.name === nameSelect)?.icon}</div>
              <div>{nameSelect}</div>
            </div>
          ) : <div style={{ marginTop: '2px' }}>{nameSelect}</div>}
        </span>
        {!disabled && (
          <img
            className={!show ? 'select-drop-icon ' : 'select-drop-icon up-down-icon '}
            src={DROPDOWN_TAG_ICON}
            alt=''
          />
        )}
        <img src={ONE_LINE} alt='' className='orange-line position-absolute' />
        {show && !disabled && !isShowModal && (
          <ul className='select-content-dropdown'>
            {dataSelect?.length ? (
              dataSelect.map((item: any, index: any) => (
                <li
                  key={index}
                  onClick={() => {
                    onSelected(item)
                    setShow(false)
                  }}
                  className={`li-item ${nameSelect == item?.name ? 'active' : ''}`}
                >
                  <div>
                    {isShowIcon && (
                      item.icon
                    )}
                  </div>
                  <div>{item?.name}</div>
                </li>
              ))) : (
                <li
                  className='li-item'
                >
                  <div>{t(`${GUILD_MESSAGE}.noData`)}</div>
                </li>
              )}
            <div className='bottom_line'></div>
          </ul>
        )}
      </div>
    </SelectCustomStyled>
  )
}
export default SelectCustomCreateRace
